module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av171-ea192e320ba96ba4fd90bc1382212eec.jpg";